<template>
  <CompanyTabs content-id="education_detail_switcher_list"
               nav-id="education_detail_switcher_tab"
               :tabs="tabs"
  >
    <EducationDescriptionTab :external-package-url="externalPackageUrl"
                             :item="item"
                             :scorm-package-url="scormPackageUrl"
                             :selected-content="selectedContent"
                             :success-message="successMessage"
                             @content-select="$emit('content-select', $event)"
    />
    <EducationPurchaseRequestsTab :item="item"
                                  :message="message"
                                  :request-types="requestTypes"
                                  @remove-purchase="forwardRemovePurchase"
                                  @send-message="$emit('send-message')"
                                  @update:message="$emit('update:message', $event)"
    />
    <EducationFeedbacksTab :item="item"/>
  </CompanyTabs>
</template>

<script>
import CompanyTabs from "@/view/company/components/tabs/CompanyTabs.vue";
import EducationDescriptionTab from "./EducationDescriptionTab.vue";
import EducationFeedbacksTab from "./EducationFeedbacksTab.vue";
import EducationPurchaseRequestsTab from "./EducationPurchaseRequestsTab.vue";

export default {
  name: "EducationDetailsTabs",
  components: {
    CompanyTabs,
    EducationDescriptionTab,
    EducationFeedbacksTab,
    EducationPurchaseRequestsTab,
  },
  props: {
    item: {
      type: Object,
      default: () => ({}),
    },
    selectedContent: {
      type: Object,
      default: null,
    },
    scormPackageUrl: {
      type: String,
      default: null,
    },
    externalPackageUrl: {
      type: String,
      default: null,
    },
    successMessage: {
      type: String,
      default: null,
    },
    message: {
      type: String,
      default: "",
    },
    requestTypes: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    tabs() {
      return [
        {
          key: "descriptions",
          icon: "uil-list-ul",
          label: this.$t("education.descriptions"),
        },
        {
          key: "purchase-requests",
          icon: "uil-receipt",
          label: this.$t("general.my_purchase_requests"),
        },
        {
          key: "feedbacks",
          icon: "uil-comment-info-alt",
          label: this.$t("education.Sharing_Experience"),
        },
      ];
    },
  },
  methods: {
    forwardRemovePurchase(id, index) {
      this.$emit("remove-purchase", id, index);
    },
  },
};
</script>
